module.exports = __webpack_public_path__ + "img/offline.165f9dc5.svg";